import * as actionType from "./actionTypes";
import { updateObject, createReducer, setItemEditing, updateItem, editItemProp, deleteItem, editItemPropByID } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  collection: {
    byID: {},
    allIDs: [],
  },
  collectionEditing: null,
};

const receiveCollections = (state, action) => (
  updateObject(state, {
    collection: action.collection,
  })
);

const reorderCollections = (state, action) => (
  updateObject(state, {
    collection: updateObject(state.collection, {
      allIDs: action.newOrder,
    }),
  })
);

const reducer = createReducer(initialState, {
  [actionType.RECEIVE_COLLECTIONS]: receiveCollections,

  [actionType.SET_COLLECTION_EDITING]: setItemEditing("collection"),
  [actionType.EDIT_COLLECTION_PROP]: editItemProp("collection"),
  [actionType.EDIT_COLLECTION_BY_ID_PROP]: editItemPropByID("collection"),
  [actionType.UPDATE_COLLECTION]: updateItem("collection"),
  [actionType.DELETE_COLLECTION]: deleteItem("collection"),
  [actionType.REORDER_COLLECTIONS]: reorderCollections,
});

export default reducer;

// SELECTORS
export const getCollections = (state) => (
  state.collection.allIDs.map((id) => state.collection.byID[id])
);

export const getCollectionEditing = (state) => (
  state.collectionEditing
);
